import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Row,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
} from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { BOM } from "../../../../../services/definedMethod";
import styles from "../../../../../assets/styles/styles";

const MapPenalties = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    userData,
    isLoading,
    setIsLoading,
    mapPenaltyTableSource,
    setMapPenaltyTableSource,
    penaltyOptions,
    incomeAccountOptions,
    chargesOptions,
    penaltyCount,
    setPenaltyCount,
  } = props;
  const { session } = userData;
  const { Title } = Typography;

  // DECLARED VARIABLES FOR FORM
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleMapPenaltyDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.incomeAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = mapPenaltyTableSource.filter(
          (item) => item.id !== key.id
        );
        setMapPenaltyTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Penalty",
      dataIndex: "penaltyValue",
    },
    {
      title: "Income Account",
      dataIndex: "incomeAccountValue",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        mapPenaltyTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleMapPenaltyDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Map Penalties to Specific Income Accounts
        </Title>
      </Divider>
      <FundSourceModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        penaltyOptions={penaltyOptions}
        incomeAccountOptions={incomeAccountOptions}
        chargesOptions={chargesOptions}
        setMapPenaltyTableSource={setMapPenaltyTableSource}
        mapPenaltyTableSource={mapPenaltyTableSource}
        session={session}
        penaltyCount={penaltyCount}
        setPenaltyCount={setPenaltyCount}
      />

      {mapPenaltyTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {mapPenaltyTableSource.length > 1
                ? "Selected Income Accounts"
                : "Selected Income Account"}
            </Title>
          </Divider>

          <Col span={24}>
            <Table
              columns={columns}
              dataSource={mapPenaltyTableSource}
              bordered
              pagination={{
                position: "bottomCentre",
                pageSize: "10",
              }}
            />
          </Col>


        </>
      )}
    </>
  );
};
export default MapPenalties;

const FundSourceModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setMapPenaltyTableSource,
    mapPenaltyTableSource,
    isModalOpen,
    setIsModalOpen,
    penaltyOptions,
    incomeAccountOptions,
    chargesOptions,
    penaltyCount,
    setPenaltyCount,
  } = props;

  const [useForm] = Form.useForm();


  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleMapPenaltySave = (formValues) => {
    const newCharges = {
      key: penaltyCount,
      id: penaltyCount,
      incomeAccountPenalty: formValues.incomeAccountPenalty,
      penalty: formValues.penalty,
      penaltyValue: penaltyOptions.find(
        (item) => item.value === formValues.penalty
      ).label,
      incomeAccountValue: incomeAccountOptions.find(
        (item) => item.value === formValues.incomeAccountPenalty
      ).label,
    };
    setPenaltyCount(penaltyCount + 1);
    setMapPenaltyTableSource([...mapPenaltyTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#15CCAE",
          marginBottom: 20,
        }}
        shape="round"
      >
        {"Map Penalties to Income"}
      </Button>

      <Modal
        title="Income Account Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleMapPenaltySave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"penalty"}
                label={"Penalty"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Penalty"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg("Penalty", "select")}
                  options={penaltyOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"incomeAccountPenalty"}
                label={"Income Account"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Income Account"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Income Account",
                    "select"
                  )}
                  options={incomeAccountOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
